export default __webpack_public_path__ + "static/media/circle.fc7e9815.svg";